import apiClient from './apiClient';
import type { ApiResponse } from '../types/api';
import type { TnmStaging, TnmStagingInput } from '../features/consultations/types/consultation.types';

export const tnmStagingService = {
    /**
     * Get TNM staging for a consultation
     */
    async get(consultationId: number): Promise<TnmStaging | null> {
        try {
            const response = await apiClient.get<ApiResponse<TnmStaging>>(
                `/consultations/${consultationId}/tnm-staging`
            );
            return response.data.data;
        } catch (error: unknown) {
            if (error && typeof error === 'object' && 'response' in error) {
                const err = error as { response?: { status?: number } };
                if (err.response?.status === 404) {
                    return null;
                }
            }
            throw error;
        }
    },

    /**
     * Create or update (upsert) TNM staging for a consultation
     */
    async upsert(consultationId: number, data: TnmStagingInput): Promise<TnmStaging> {
        const response = await apiClient.post<ApiResponse<TnmStaging>>(
            `/consultations/${consultationId}/tnm-staging`,
            data
        );
        return response.data.data;
    },

    /**
     * Delete TNM staging for a consultation
     */
    async delete(consultationId: number): Promise<void> {
        await apiClient.delete(`/consultations/${consultationId}/tnm-staging`);
    },
};
